<template>
    <v-dialog v-model="showModal" persistent :width="$vuetify.breakpoint.thresholds.sm">
        <template #activator="{ on, attrs }">
            <v-tooltip bottom>
                <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                    <v-btn icon v-on="{ ...on, ...tooltipOn }" v-bind="{ ...attrs, ...tooltipAttrs }" :disabled="!isSelected" color="error">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('Thema löschen') }}</span>
            </v-tooltip>
        </template>
        <DeleteConfirm
            :hasToolbar="true"
            :toolbarTitle="$t('Thema löschen')"
            :deleteMessage="$t('Sind Sie sicher, dass Sie dieses Thema löschen möchten?')"
            :checkboxDeleteMessage="$t('Diese Aktion kann nicht rückgängig gemacht werden.')"
            @deleteItem="deleteTopic"
            @closeEmit="close"
        />
    </v-dialog>
</template>
<script>
import CourseMixin from './Mixins/CourseMixin';
import DeleteConfirm from '../../Generic/DeleteConfirm';

export default {
    name: 'delete-topic',
    mixins: [CourseMixin],
    data: () => ({
        showModal: false
    }),
    components: {
        DeleteConfirm
    },
    computed: {
        isSelected() {
            return Object.keys(this.getSelectedTopic).length > 0;
        }
    },
    methods: {
        close() {
            this.showModal = false;
        },
        deleteTopic() {
            this.DELETE_TOPIC(this.getSelectedTopic)
                .then(() =>
                    this.UPDATE_COURSE_TOPICS({
                        course: this.getSelectedAdminCourse,
                        topics: [...this.getCourseTopics]
                    })
                )
                .then(() => this.close());
        }
    }
};
</script>
